// Preferência de experiência (teste controlado da nova tela "Visão geral").
// Guardada em localStorage: persiste entre sessões — enquanto "new", o usuário
// sempre cai na nova tela, mesmo após fechar o navegador.
export const OVERVIEW_EXPERIENCE_KEY = "kf_overview_experience";

export const enableNewExperience = (): void => {
  window.localStorage.setItem(OVERVIEW_EXPERIENCE_KEY, "new");
};

export const disableNewExperience = (): void => {
  window.localStorage.setItem(OVERVIEW_EXPERIENCE_KEY, "old");
};

export const isNewExperiencePreferred = (): boolean => window.localStorage.getItem(OVERVIEW_EXPERIENCE_KEY) === "new";
